import React, { useContext, useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { TitleText, LabelText } from "../../ui/Text";
import { TimelineTaskInfoSubject } from "../../subjects/TimelineTaskInfoSubject";
import { get } from "../../utils/get";
import { Clock } from "../../assets/svg/Clock";
import { Field, Formik } from "formik";
import { DropDown } from "../../ui/DropDown";
import { AttendeeCard } from "../../components/AttendeeCard";
import Avatar from "../../ui/Avatar";
import { SendButton } from "../../assets/svg/SendButton";
import { AttachButton } from "../../assets/svg/AttachButton";
import Input from "../../ui/Input";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import moment from "moment";
import { AuthContext } from "../../context/AuthContext";
import useDebounce from "../../utils/useDebounce";
import Axios from "../../utils/axios";
import { TASKS_URL } from "../../api/urls";
import { toast } from "react-toastify";
import { EditIcon } from "../../assets/svg/EditIcon";
import { Button } from "../../ui/Button";
import { DeleteHook, GetHook } from "../../api/api";
import { useLocation } from "react-router-dom";
import Modal from "../../ui/Modal";
import { AddInitiative } from "../plan/AddInitiative";
import { DeleteIcon } from "../../assets/svg/DeleteIcon";
import TaskEmptyState from "../../assets/svg/TaskEmptyState";

export const TaskList = ({ handleStatusUpdate }) => {
  const [taskInfoData, setTaskInfoData] = useState({});
  const [updateActual, setUpdateActual] = useState("");
  const [comments, setComments] = useState<any>([]);
  const [isModalOpen, setisModalOpen] = useState(false);
  const [deleteURL, setDeleteURL] = useState("null");
  const [taskStatus, setTaskStatus] = useState([]);
  const [selectedFile, setSelectedFile] = useState<any |null >(null);
	const [isFilePicked, setIsFilePicked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [files, setFiles] = useState<any>([]);
  const formRef: any = useRef<any>(null);
  const inputFile = useRef<any>(null) 

  const auth = useContext(AuthContext);
  const location = useLocation();
  const {
    data: deleteRes,
    error: deleteError,
    pending: deletePending,
  } = DeleteHook(deleteURL);
  const { data, reload } = GetHook(
    get(taskInfoData, "id")
      ? `${TASKS_URL}/${get(taskInfoData, "id")}/comment`
      : "null"
  );

  const { user } = get(auth, "authState");
  useEffect(() => {
    const TaskData = TimelineTaskInfoSubject.subscribe((payload) => {
      setTaskInfoData(payload);
      const ownerStatus =
        get(payload, "owners") &&
        get(payload, "owners").filter(
          (owner) => owner.owner_id === get(user, "id")
        );
      let status =
        get(ownerStatus, "[0]status") === "complete"
          ? {
              label: "Complete",
              value: "complete",
              icon: <StatusIcon color={getColor("complete")} />,
            }
          : {
              label: "In Progress",
              value: "active",
              icon: <StatusIcon />,
            };
      formRef.current?.setFieldValue("status", status);
      
    });
    return () => {
      TaskData.unsubscribe();
    };
  }, [user]);

  useEffect(() => {
    setComments(data);
    return () => {};
  }, [data]);

  const handleUpdateActaul = (values) => {
    const payload =
      updateActual === "length"
        ? { actual_length: get(values, "actual_length") }
        : { actual_budget: get(values, "actual_budget") };

    Axios.put(`${TASKS_URL}/${get(taskInfoData, "id")}`, payload).then(
      (res) => {
        toast.success("Actual budget updated");
        setTaskInfoData(res?.data?.returned_resultset[0]);
        setUpdateActual("");
      }
    );
  };

  const handleComment = (values, resetForm) => {
    // const payload = {
    //   source_user_id: get(user, "id"),
    //   comment: get(values, "comment"),
    // };
    let payload;
    payload = new FormData();
    payload.append("source_user_id", get(user, "id"));
    payload.append("comment", get(values, "comment"));
      files.map((file) => {
        payload.append("documents", get(file, "file"));
        payload.append("document_name", get(file, "name"));
      });

    Axios.post(`${TASKS_URL}/${get(taskInfoData, "id")}/comment`, payload).then(
      (res) => {
        toast.success("Comment posted");
        resetForm({ comment: "" });
        reload(get(location, "key"));
      }
    );
  };
  useEffect(() => {
    if (deleteRes && !deleteError && !deletePending) {
      toast.success("Deleted successfully!");
      reload(get(location, "key"));
    } else if (deleteRes && deleteError && !deletePending) {
      toast.error(`Delete failed: ${get(deleteError, "data.message")}`);
    }
    return () => {};
  }, [deleteRes, deleteError, deletePending]);

  const getColor = (priority) => {
    switch (true) {
      case priority === "high":
        return "#D51067";
      case priority === "medium":
        return "#EDBC0C";
      default:
        return "#13C997";
    }
  };

  const changeHandler = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsFilePicked(true);
	};

  const handleFileUpload = (values) => {
    console.log(values);
  };
  


  if (!taskInfoData)
    return (
      <TaskEmptyStateContainer>
        <TaskEmptyState />
        <TitleText>No Task Selected</TitleText>
      </TaskEmptyStateContainer>
    );

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        status: "",
        actaul_length: "",
        comment: "",
      }}
      onSubmit={() => console.log("submit")}
    >
      {({ values, resetForm }) => (
        <>
          {isModalOpen && (
            <Modal
              title="add task"
              noHeader
              noFooter
              closeModal={() => setisModalOpen(false)}
            >
              <AddInitiative
                isOpen={isModalOpen}
                isEdit
                editData={[taskInfoData]}
                onClick={() => setisModalOpen(false)}
                user={user}
              />
            </Modal>
          )}
          <TaskListContainer>
            <TaskListHeader>
              <LabelText>
                <Clock /> Due
                <TitleText
                  style={{
                    display: "inline-block",
                    paddingLeft: "1em",
                    fontSize: "12px",
                  }}
                >
                  {moment(get(taskInfoData, "due_date", "")).format(
                    "DD MMM YYYY, h a"
                  )}
                </TitleText>
              </LabelText>
              <div>
                <LabelText
                  color="#01A8CE"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setisModalOpen(true);
                  }}
                >
                  <EditIcon /> <span>Edit</span>
                </LabelText>
                <LabelText
                  color="#EC6465"
                  style={{ cursor: "pointer", marginLeft: "1em" }}
                  onClick={() =>
                    setDeleteURL(`${TASKS_URL}/${get(taskInfoData, "id")}`)
                  }
                >
                  <DeleteIcon /> <span>Delete</span>
                </LabelText>
              </div>
            </TaskListHeader>
            <TitleText
              style={{ paddingBottom: "1em", gridColumn: "1/ span 2" }}
            >
              {get(taskInfoData, "name")}
            </TitleText>
            <Description>
              <LabelText>Created By</LabelText>
              <TitleText>
                {get(taskInfoData, "created_by_user.names", "-")} ,
                <LabelText
                style={{
                  display: "inline-block",
                  paddingLeft: "1em",
                  fontSize: "12px",
                }}
                >
                {moment(get(taskInfoData, "created_at", "")).format(
                    "DD MMM YYYY, h a"
                  )}
                  </LabelText>
              </TitleText>
            </Description>
            <Description>
              <LabelText>Task Description</LabelText>
              <TitleText>{get(taskInfoData, "notes")}</TitleText>
            </Description>
            <TaskPriority>
              <LabelText>Task Priority</LabelText>
              <Priority>
                <StatusIcon color={getColor(get(taskInfoData, "priority"))} />
                <TitleText>{get(taskInfoData, "priority")}</TitleText>
              </Priority>
            </TaskPriority>
            <Field
              name="status"
              component={DropDown}
              options={
                get(taskInfoData, "owners") &&
                get(taskInfoData, "owners").filter(
                  (owner) => owner.id === get(user, "id")
                )
                  ? [
                      {
                        label: "In Progress",
                        value: "active",
                        icon: <StatusIcon />,
                      },
                      {
                        label: "Complete",
                        value: "complete",
                        icon: <StatusIcon color={getColor("complete")} />,
                      },
                    ]
                  : [{ label: "Approved", value: "Approved" }]
              }
              width="90%"
              dropdownLabel="Task Status"
              onChange={(values) =>
                handleStatusUpdate(
                  get(taskInfoData, "id"),
                  get(values, "value")
                )
              }
              isClearable={false}
              backgroundColor="#f5f6fb"
            />

            <AssignedContainer>
              <LabelText>Assignment</LabelText>
              <OwnersContainer>
              {get(taskInfoData, "owners") &&
                get(taskInfoData, "owners").map((owner, index) => {
                  return (
                    <AttendeeCard
                      style={{ marginTop: 0 }}
                      key={index}
                      data={owner}
                    />
                  );
                })}
                </OwnersContainer>
            </AssignedContainer>
            <LabelText>Cost</LabelText>
            <TaskCard>
              <Title>Budget</Title>
              <TitleText>KSH {get(taskInfoData, "budget")}</TitleText>
            </TaskCard>
            {updateActual === "budget" ? (
              <UpdateInputComponent>
                <Field
                  name="actual_budget"
                  label="Actual"
                  component={Input}
                  width="80%"
                  placeholder="Update actual budget"
                />
                <SaveButton
                  text="save"
                  onClick={() => handleUpdateActaul(values)}
                />
              </UpdateInputComponent>
            ) : (
              <TaskCard>
                <TaskCardHeader>
                  <Title>Actual</Title>
                  <LabelText
                    color="#01A8CE"
                    style={{ cursor: "pointer" }}
                    onClick={() => setUpdateActual("budget")}
                  >
                    <EditIcon /> Update
                  </LabelText>
                </TaskCardHeader>
                <TitleText>KSH {get(taskInfoData, "actual_budget")} </TitleText>
              </TaskCard>
            )}

            <LabelText>Time</LabelText>
            <TaskCard>
              <Title>Budget</Title>
              <TitleText>
                {get(taskInfoData, "length")}{" "}
                {get(taskInfoData, "length_type") &&
                  get(taskInfoData, "length_type").toUpperCase()}
              </TitleText>
            </TaskCard>
            {updateActual === "length" ? (
              <UpdateInputComponent>
                <Field
                  name="actual_length"
                  label="Actual"
                  component={Input}
                  width="80%"
                  placeholder="Update actual length"
                />
                <SaveButton
                  text="save"
                  onClick={() => handleUpdateActaul(values)}
                />
              </UpdateInputComponent>
            ) : (
              <TaskCard>
                <TaskCardHeader>
                  <Title>Actual</Title>
                  <LabelText
                    color="#01A8CE"
                    style={{ cursor: "pointer" }}
                    onClick={() => setUpdateActual("length")}
                  >
                    <EditIcon /> Update
                  </LabelText>
                </TaskCardHeader>
                <TitleText>
                  {get(taskInfoData, "actual_length")}{" "}
                  {get(taskInfoData, "length_type") &&
                    get(taskInfoData, "length_type").toUpperCase()}
                </TitleText>
              </TaskCard>
            )}

            <TaskCommentContainer>
              <TitleText>Comments</TitleText>
              {comments.map((comment) => {
                return (
                  <MessageContainer>
                    <Avatar
                      url={
                        comment.source_user.avatar_url ||
                        `https://ui-avatars.com/api/?name=${comment.source_user.names}`
                      }
                    />
                    <MessageContent>
                      <TitleText>{comment.source_user.names}</TitleText>
                      <Comment>{comment.comment}</Comment>
                    </MessageContent>
                  </MessageContainer>
                );
              })}
            </TaskCommentContainer>
            <InputContainer>
              <Field
                name="comment"
                component={Input}
                width="99%"
                placeholder="Write your comment"
                height="28px"
              />
              {/* <Acon onClick={() => setIsOpen(true)}>
                <AttachButton
                />
              </Acon>
                      <FilePicked>
                        <p>{files[0]?.file.name}</p>

                      </FilePicked> */}
              {isOpen && (
              <Modal
                title="add documents"
                noFooter
                noHeader
                width="30%"
                closeModal={() => setIsOpen(false)}
              >
                <Formik
                  initialValues={{ name: "", file: "" }}
                  onSubmit={(values) => handleFileUpload(values)}
                >
                  {({ setFieldValue, values, handleSubmit }) => (
                    <FileUploadContainer>
                      <TitleText style={{ fontSize: 16 }}>
                        Add Documents
                      </TitleText>
                      <Documents>
                        {files &&
                          files.map((file, index) => {
                            return (
                              <>
                                <Text style={{ fontSize: 14, color: "black" }}>
                                  {get(file, "name")} ({get(file, "file.name")})
                                </Text>{" "}
                                <span
                                  onClick={() =>
                                    setFiles(
                                      files.filter(
                                        (file, i) => files[i] !== files[index]
                                      )
                                    )
                                  }
                                >
                                  x
                                </span>
                              </>
                            );
                          })}
                      </Documents>
                      <Field
                        name="name"
                        type="text"
                        label="Document Name"
                        component={Input}
                        width="90%"
                        isBordered={true}
                        placeholder="Name"
                      />
                      <Label>
                        
                        <TitleText style={{ color: "#01A8CE" }}>
                          +Add File
                        </TitleText>
                        <input
                          type="file"
                          name="file"
                          onChange={(e: any) => {
                            setFieldValue("file", e.target.files[0]);

                            const obj = {
                              name: get(values, "name"),
                              file: e.target.files[0],
                            };
                            setFiles([...files, obj]);
                          }}
                          style={{ display: "none" }}
                        />
                      </Label>
                      <EditButtons>
                        <EditButton
                          text="Cancel"
                          backgroundColor="#fff"
                          color="#214160"
                          onClick={() => setIsOpen(false)}
                        />
                        <EditButton
                          text="Done"
                          onClick={() => setIsOpen(false)}
                        />
                      </EditButtons>
                    </FileUploadContainer>
                  )}
                </Formik>
              </Modal>
            )}
               {/* <input
                name="file"
                id="file"
                type='file'
                value={selectedFile}
                onChange={changeHandler}
                style={{display: 'none'}}
              />
              <Acon >
                <label htmlFor="file">
                <AttachButton
                />
                </label>
              </Acon>
              {isFilePicked? (
                      <div>
                        <p>Filename: {selectedFile.name}</p>
                        <p>Filetype: {selectedFile.type}</p>

                      </div>
                    ) : (
                      <p></p>
                    )} */}

              <Icon onClick={() => handleComment(values, resetForm)}>
                <SendButton />
              </Icon>
            </InputContainer>
          </TaskListContainer>
        </>
      )}
    </Formik>
  );
};

const TaskListContainer = styled.div`
  background-color: #fff;
  display: grid;
  grid-column-gap: 3em;
  grid-template-columns: 1fr 1fr;
  border-radius: 10px;
  padding: 1em 1.5em 1em 1.5em;
  ${LabelText} {
    align-items: center;
    grid-column: 1 / span 2;
    padding-bottom: 1em;
    font-size: 12px;
  }
`;

const TaskEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  ${TitleText} {
    margin-top: 1em;
    font-size: 20px;
  }
`;

const TaskListHeader = styled.div`
  display: flex;
  grid-column: 1 / span 2;
  justify-content: space-between;
  ${TitleText} {
    font-size: normal;
    font-weight: 600;
  }
  ${LabelText} {
    align-items: center;
    grid-column: 1 / span 2;
  }
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 2;
  padding-bottom: 1em;
  ${LabelText} {
    padding-bottom: 0.5em;
  }
  ${TitleText} {
    font-size: 12;
    font-weight: normal;
  }
`;

const TaskCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f6fb;
  padding: 1.5em;
  margin-bottom: 1em;
  margin-right: 1em;
  border-radius: 1em;
  ${TitleText} {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
  }
`;
const TaskCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Title = styled.h5`
  margin: 0;
  font-weight: normal;
  font-size: 14px;
  color: #214160;
  opacity: 0.5;
  margin-bottom: 1em;
`;

export const TaskCommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 2;
  padding-top: 1em;
  width: 97.5%;
  ${TitleText} {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    padding-bottom: 1em;
  }
`;

export const AssignedContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 2;
  width: 97.5%;
  padding-top: 1.5em;
  padding-bottom: 1em;
  height: 40vh;
  overflow: hidden;
  &:hover {
    overflow-y: scroll;
  }
`;
export const OwnersContainer = styled.div`
  height: 40vh;
  overflow: hidden;
  &:hover {
    overflow-y: scroll;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f5f6fb;
  padding: 1em;
  border-radius: 1em;
  margin-bottom: 1em;
`;

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 1em;
  align-items: baseline;
  ${TitleText} {
    font-size: 12;
    padding-bottom: 0.5em;
    margin: 0;
    margin-block-end: 0;
    margin-block-start: 0;
  }
`;
const Comment = styled.h2`
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  color: #214160;
  margin: 0;
  padding: 0;
  margin-block-end: 0;
  margin-block-start: 0;
`;

export const InputContainer = styled.div`
  margin-bottom: 10px;
  position: relative;
  width: 93.5%;
  grid-column: 1 / span 2;
`;
const InputComment = styled.input`
  width: 100%;
  padding: 10px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
`;
const Icon = styled.span`
  position: absolute;
  padding: 15px;
  color: rgb(49, 0, 128);
  width: 70px;
  top: 18%;
  left: 95%;
`;

const Acon = styled.span`
  position: absolute;
  padding: 15px;
  color: rgb(49, 0, 128);
  width: 70px;
  top: 18%;
  left: 85%;
`;

const FilePicked = styled.span`
  position: absolute;
  padding: 15px;
  width: 70px;
  top: 60%;
  left: 0%;
`;

const TaskPriority = styled.div`
  display: flex;
  flex-direction: column;
  ${LabelText} {
    font-size: 12px;
  }
`;

const UpdateInputComponent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SaveButton = styled(Button)`
  margin-top: 2em;
  padding: 0.85em 2em;
`;

const Priority = styled.div`
  display: flex;
  align-items: center;
  height: 38px;

  background: #f5f6fb;
  border-radius: 8px;
  padding: 0 1em;
  ${TitleText} {
    padding-left: 1em;
  }
`;

const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Documents = styled.div`
  display: grid;
  grid-template-columns: 2fr 0.5fr;
  row-gap: 0.75em;
  padding-top: 1em;
  padding-bottom: 1em;
  span {
    cursor: pointer;
  }
`;
const Text = styled.p`
  font-size: 14px;
  font-weight: nomarl;
  margin: 0;
  align-items: center;
  line-height: 1.5em;
  color: ${(props) => props.color || "#ccc"};
`;

const Label = styled.label`
  display: flex;
  flex-direction: column;
  color: #01A8CE;
  font-family: "Raleway", sans-serif;
  font-size: 0.8em;
  margin: 0.5em 0;
  position: relative;
`;

const EditButton = styled(Button)`
  margin-left: 1em;
  padding: 0.5em 1em;
`;

const EditButtons = styled.div`
  display: flex;
  flex-direction: row;
`;